"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubAdminUsers = void 0;
var react_1 = __importDefault(require("react"));
var UsersView_1 = require("./components/UsersView");
var use_users_view_model_1 = require("./hooks/use-users-view-model");
require("./styles/users.scss");
/**
 * WsAiHubAdminUsers - User management area for AI Hub admin.
 */
var WsAiHubAdminUsers = function () {
    var viewModel = use_users_view_model_1.useUsersViewModel();
    return react_1.default.createElement(UsersView_1.WsUsersView, { viewModel: viewModel });
};
exports.WsAiHubAdminUsers = WsAiHubAdminUsers;
